import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_CONSULTA_POR_COSECHA } from '../../../../config/tables'

export default function ConsultaPorCosechaView () {
  return <MuiTable id={TABLA_CONSULTA_POR_COSECHA} />
}
